import React, { useEffect } from 'react';
import { useSSR } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { StyleSheetManager, ThemeProvider } from 'styled-components';

import isPropValid from '@emotion/is-prop-valid';
import { trackPageTranslation } from 'apps/promo/analytics/pageTranslation';
import LandingNewPage from 'apps/promo/components/LandingPage/LandingNewPage';
import PromoErrorBoundary from 'apps/promo/components/utils/PromoErrorBoundary';
import { getThemeFromUrl } from 'apps/promo/helpers/theme';
import getStore from 'apps/promo/redux/store';
import pallets from 'apps/promo/theme/pallets';
import { hydrateRoot } from 'react-dom/client';

import 'apps/promo/components/i18n';
import 'static/css/global.css';
import 'apps/promo/theme/colors.css';
import 'apps/promo/theme/rebranding.css';
import 'static/css/promo-common.css';
import 'static/css/fonts.css';

const preloadedState = window.__INITIAL_STATE__;
delete window.__INITIAL_STATE__;

const store = getStore(preloadedState);

const LandingHydryte = () => {
    useEffect(() => trackPageTranslation(), []);
    useSSR(window.initialI18nStore, window.initialLanguage);

    const theme = getThemeFromUrl(location.search);

    return (
        <BrowserRouter>
            <StyleSheetManager shouldForwardProp={isPropValid}>
                <ThemeProvider theme={pallets[theme]}>
                    <Provider store={store}>
                        <PromoErrorBoundary>
                            <LandingNewPage />
                        </PromoErrorBoundary>
                    </Provider>
                </ThemeProvider>
            </StyleSheetManager>
        </BrowserRouter>
    );
};

const container = document.getElementById('app');
hydrateRoot(container, <LandingHydryte />);
